<app-org-name-heading [showHostedState]="true"></app-org-name-heading>

<div class="contents">
  <h2>Try us for free, or go straight to a paid plan:</h2>

  <app-subscription-plans [onboarding]="true"
                          [showHosted]="!org.prefer_self_host"
                          (selected)="planSelected($event)"></app-subscription-plans>
</div>
